<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Produto Distribuidor</strong>
          </div>
          <modal-select label="Distribuidor" modal="dealers-modal" v-validate="'required'" name="dealer_id" v-bind:readonly="false" v-bind:item-id="item.dealer_id" v-bind:item-name="item.dealer.data.name" v-on:select-item="selectDealer"  :state="validateState('dealer_id')"  ></modal-select>
          <modal-select label="Produto" modal="products-modal" v-validate="'required'" name="product_id" v-bind:readonly="false" v-bind:item-id="item.product_id" v-bind:item-name="item.product.data.name" v-on:select-item="selectProduct"  :state="validateState('product_id')"  ></modal-select>

          <b-form-fieldset label="Código">
            <b-form-input type="text" name="code" v-model="item.code" placeholder="Código"  v-validate="'required'" :state="validateState('code')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('code') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-row>
            <b-form-group label="Data de ínicio" description="(AAAA-mm-dd)" class="col-md-3">
              <input type="text" v-model="item.date_start" v-mask="'####-##-##'" class="form-control" placeholder="Data de ínicio" />
            </b-form-group>
            <b-form-group label="Data de fim" description="(AAAA-mm-dd)" class="col-md-3">
              <input type="text" v-model="item.date_end" v-mask="'####-##-##'" class="form-control" placeholder="Data de fim" />
            </b-form-group>
            <b-form-group label="Quantidade"  class="col-md-3">
              <b-form-input type="text" name="quantity" v-model="item.quantity" placeholder="Quantidade"  v-validate="'required'" :state="validateState('quantity')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('quantity') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'dealerproducts.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">

      </b-col>
    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'DealersEdit',
  props: ['id'],
  data() {
    return {
      dataLoaded: false,
      item: {
        name: '',
        code: '',
        dealer: {
          data: []
        },
        product: {
          data: []
        }
      },
      stateOptions: lists.states,
      dsrTypes: lists.dsrTypes
    }
  },
  methods: {
    selectDealer(e) {
      if(e.item) {
        this.item.dealer_id = e.item.id
        this.item.dealer.data = e.item
      } else {
        this.item.dealer_id = null
        this.item.dealer.data = {id: null, name:null}
      }
    },
    selectProduct(e) {
      if(e.item) {
        this.item.product_id = e.item.id
        this.item.product.data = e.item
      } else {
        this.item.product_id = null
        this.item.product.data = {id: null, name:null}
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('dealer-products' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'dealerproducts.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('dealer-products', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'dealerproducts.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('dealer-products' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'dealerproducts.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
